import type { CSSProperties } from "react";

import { HourglassMark } from "@/components/HourglassMark";

type HourglassLoaderProps = {
  size?: number;
  className?: string;
  style?: CSSProperties;
  label?: string;
  /** Slower rotation (e.g. full-app loading screen). */
  slow?: boolean;
};

/**
 * Loading state: rotating hourglass mark (replaces generic circular spinners).
 */
export function HourglassLoader({ size = 40, className, style, label = "Loading", slow = false }: HourglassLoaderProps) {
  return (
    <div
      className={`ed-hourglass-loader${slow ? " ed-hourglass-loader--slow" : ""}${className ? ` ${className}` : ""}`}
      style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", ...style }}
      role="status"
      aria-live="polite"
      aria-label={label}
    >
      <HourglassMark size={size} aria-hidden />
    </div>
  );
}
